import {useEffect} from "react";
import {toast} from "react-toastify";
import {errorCodeHandler} from "@/utils/global-functions";

export default function ErrorHandlerLayout({pageProps = {}, children}) {

    useEffect(() => {
        const {error = null} = (pageProps && pageProps.data) || {};
        if(error) {
            const {message, statusCode, reFetchCallback} = error;
            if(statusCode >= 500) {
                errorCodeHandler(statusCode, reFetchCallback)
            } else {
                toast.error(message);
            }
        }
    }, []) // eslint-disable-line

    return (
        <>
            {children}
            <div id="re-fetch-container"
                 className="fixed z-[10000] w-screen h-screen bg-white/90 left-0 top-0 hidden justify-center items-center"
            style={{zIndex: "10000", backgroundColor: 'rgba(256,256,256,0.9)'}}>
                <div className="text-center">
                    <p className="font-bold">خطایی پیش آمد دوباره امتحان کنید</p>
                    <button className="btn-main px-10 py-2.5 mt-5 text-sm" id="re-fetch-btn">امتحان دوباره</button>
                </div>
            </div>
        </>
    );
}
